export default __webpack_public_path__ + "static/media/step-2.b2bb45f6.png";